import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'antd';
import CreateGlobalStyle from './reset';

type Props = {
	title: string;
	source: Blob;
	renderMode?: 'modal' | 'popup';
	onClose?: () => void;
};

const PDFBlobViewer: React.FC<Props> = ({
	title,
	source,
	renderMode = 'modal',
	onClose,
}) => {
	const [isVisible, setIsVisible] = useState<boolean>(false);
	const [blobUrl, setBlobUrl] = useState<string>('');

	const renderPopup = useCallback((url: string) => {
		const win = window.open(
			url,
			'_blank',
			'location=yes,height=800,width=800,scrollbars=yes,status=false',
		);
		if (!win) {
			console.error('Popup bloqueado pelo navegador!');
		}
	}, []);

	useEffect(() => {
		if (source) {
			const pdfFile = new File([source], 'documento.pdf', {
				type: 'application/pdf',
			});

			const url = URL.createObjectURL(pdfFile);
			setBlobUrl(url);

			if (renderMode === 'popup') renderPopup(url);
			if (renderMode === 'modal') setIsVisible(true);

			return () => {
				URL.revokeObjectURL(url);
			};
		}
		return () => {};
	}, [source, renderMode, renderPopup]);

	const handleOnCancel = useCallback(() => {
		setIsVisible(false);
		if (onClose) onClose();
	}, [onClose]);

	return (
		<>
			<Modal
				title={title}
				visible={isVisible}
				wrapClassName="react-pdf-modal"
				style={{ animationDuration: '0s' }}
				footer={null}
				onCancel={handleOnCancel}
			>
				{blobUrl && (
					<iframe
						title={title}
						src={blobUrl}
						style={{ width: '100%', height: '100%', border: 'none' }}
					/>
				)}
			</Modal>

			<CreateGlobalStyle />
		</>
	);
};

export default PDFBlobViewer;
